import * as actionTypes from "../actionTypes.js";

const initialState = {
  companiesList: null,
  branchesList: null,
  usersList: null,
  userConsentsList: null,
  companyEmployeesList: null, 
  tenantsList: null,

  // access & security
  internalUsersList: null,
  internalUsersMfaList: null,
  internalUserSessionsList: null,
  mfaBackupCodesList: null,
  userSessionsList: null,
  identityOverview: null
};

const businessIdentityReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_COMPANIES_BIZ_IDENTITY:
      return { ...state, companiesList: action.payload };

    case actionTypes.GET_BRANCHES_BIZ_IDENTITY:
      return { ...state, branchesList: action.payload };

    case actionTypes.GET_USERS_BIZ_IDENTITY:
      return { ...state, usersList: action.payload };

    case actionTypes.GET_USER_CONSENTS_BIZ_IDENTITY:
      return { ...state, userConsentsList: action.payload };

    case actionTypes.GET_COMPANY_EMPLOYEES_BIZ_IDENTITY:
      return { ...state, companyEmployeesList: action.payload };

    case actionTypes.GET_TENANTS_BIZ_IDENTITY:
      return { ...state, tenantsList: action.payload };

    case actionTypes.GET_INTERNAL_USERS_BIZ_IDENTITY:
      return { ...state, internalUsersList: action.payload };

    case actionTypes.GET_INTERNAL_USERS_MFA_BIZ_IDENTITY:
      return { ...state, internalUsersMfaList: action.payload };

    case actionTypes.GET_INTERNAL_USER_SESSIONS_BIZ_IDENTITY:
      return { ...state, internalUserSessionsList: action.payload };

    case actionTypes.GET_MFA_BACKUP_CODES_BIZ_IDENTITY:
      return { ...state, mfaBackupCodesList: action.payload };

    case actionTypes.GET_USER_SESSIONS_BIZ_IDENTITY:
      return { ...state, userSessionsList: action.payload };

    case actionTypes.GET_IDENTITY_OVERVIEW_BIZ_IDENTITY:
      return { ...state, identityOverview: action.payload };


    case actionTypes.LOG_OUT:
      return initialState;

    default:
      return state;
  }
};

export default businessIdentityReducer;